import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_ALL_POSITION_FIELDS_MUTATION = gql`
  mutation updateAllPositionFields(
    $documentVersion: DocumentVersionInput!
    $lineId: String!,
    $lines: [LineInputType] = null,
    $quantity: Decimal!,
    $description: String!,
    $properties: [CustomPropertyInputArbonia] = null
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          setQuantity(quantity: $quantity) {
            documentId
            revision
          }
          setDescription(description: $description) {
            documentId
            revision
          }
        }
      }
    }
    custom {
      updateQuote(
        documentId: $documentVersion,
        properties: $properties,
        lines: $lines
      ) {
        documentId
        revision
        ...QuotePricingFragment
      }
    }
  }
  ${QUOTE_PRICING_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateAllPositionFieldsMutation extends Mutation<RootMutation> {
  document = UPDATE_ALL_POSITION_FIELDS_MUTATION;
}
